import React, { FC, PropsWithChildren } from "react"

import { Card, Group, Stack, Text } from "@mantine/core"
import { Icon } from "@tabler/icons-react"

type ModuleSettingsCardProps = {
    title: string
    icon: Icon
}

const ModuleSettingsCard: FC<PropsWithChildren<ModuleSettingsCardProps>> = ({ title, icon: Icon, children }) => {
    return (
        <Card withBorder>
            <Stack>
                <Group position="apart" noWrap>
                    <Text color="dimmed" weight="bold" sx={theme => ({ fontFamily: theme.headings.fontFamily })}>
                        <Group spacing="xs">
                            <Icon size={20} />
                            {title}
                        </Group>
                    </Text>
                </Group>
                {children}
            </Stack>
        </Card>
    )
}

export default ModuleSettingsCard
